<template>

  <!-- Podcast banner -->
  <div class="d-flex justify-center">
    <v-card max-width="1120" width="100%" max-height="350" elevation="8" rounded="0" class="my-6">
      <v-row no-gutters>
        <v-col cols="12" md="4">
         <!--  <div class="title font-weight-light pa-6" :class="{ 'body-1 mb-2': smAndDown }">
            <v-icon size="12" class="text-primary font-weight-bold mb-1">
              mdi-circle-outline
            </v-icon>
            {{ today }}
          </div>-->

          <img :src="podcastImage" alt="Podcast" width="100%" height="100%" class="square-img" />
        </v-col>
        <v-col cols="12" md="6" class=" d-flex flex-column justify-center">

          <h2 class="font-weight-medium">
            Odhalenie je podcast Investigatívneho centra Jána Kuciaka, v ktorom budeme prinášať audio verzie
            našich článkov, ale a rozhovory,
            v ktorých odhalíme pozadie naše práce aj káuz, ktoré prinášame.
          </h2>
          <p class="text-medium-emphasis text-body-2 mb-4">Všetky epizódy si môžete vypočuť aj na Spotify, Apple
            Podcasts či Google Podcasts</p>

        </v-col>
      </v-row>
    </v-card>
  </div>
  <!-- Common podcast -->

  <div class="articles-columns">
    <div v-for="(column, columnIndex) in articleColumns" :key="`col-${columnIndex}`" class="articles-column">
      <div v-for="(item, cardIndex) in column" :key="`${item.title}-${columnIndex}-${cardIndex}`" class="article-item">



        <!-- Podcast -->
        <v-card overflow="visible" flat class="hoverable pa-6 info-card"
          :to="'/' + item.id + '/' + getURLText(item.name)" rounded="0" :width="smAndDown ? '100%' : '350'">
          <v-row wrap style="height: 100%">
            <v-col cols="12" class="imgWrapper d-flex justify-center">
              <v-img :src="item.image + '/500'" :lazy-src="item.lazyImage ? item.lazyImage : null" height="350"
                class="hoverImg" cover flat>
                <div class="small-red-ring"></div>
                <div class="podcastSection">
                  <span>Rozhovory</span>
                  <span>o investigatívnej</span>
                  <span>žurnalistike</span>
                </div>
              </v-img>
            </v-col>

            <v-col cols="12" align-self="baseline" class="title font-weight-bold pb-0"
              :class="{ 'body-1 px-5 pb-3 ': smAndDown }">
              <span class="thick-circle"></span>
              {{ item.name }}
            </v-col>

            <v-col cols="12" :class="{
              'px-5 pb-1': smAndDown,
              'pb-3': mdAndUp
            }">
              <h2 class="mb-0 headline font-weight-regular" :class="{ 'text-primary': hover }">
                <strong>{{ item.description }}</strong>
              </h2>
            </v-col>
          </v-row>
        </v-card>

      </div>
      
    </div>
  </div>
<iframe 
  width="100%" 
  height="450" 
  scrolling="no" 
  frameborder="no" 
  allow="autoplay" 
  src="https://w.soundcloud.com/player/?url=https%3A//soundcloud.com/odhalenie_icjk&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true"></iframe>
  <v-expand-transition>
    <v-row v-show="!allLoaded" :class="{ 'ma-4': smAndDown }">
      <v-col align="center" class="bg-white">
        <v-btn class="bg-primary mt-4 ring-top-btn" :loading="loadingContent" @click="loadData({ skip: dataCount, take: 9 })"
          height="24" size="small" width="140">
          Viac
        </v-btn>
      </v-col>
    </v-row>
  </v-expand-transition>
</template>
<script setup>
import { ref, onMounted, defineProps, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useDisplay } from 'vuetify'
import unorm from 'unorm'
import axios from 'axios'
import podcastImage from '@/assets/logo-podcast.png'

const props = defineProps({
  articleUID: String
})
const route = useRoute()
const { smAndDown } = useDisplay()
const today = new Date().toLocaleDateString('sk-SK', {
  day: 'numeric',
  month: 'long',
  year: 'numeric'
})


const content = ref([])
const dataCount = ref(0)
const allLoaded = ref(false)
const loadingContent = ref(false)



const contentArticles = computed(() => {
  const result = [...content.value]

  // ak už supportCard existuje, odstráň ho (aby sa nepridával viackrát)
  const filtered = result.filter(item => !item?.supportCard)

  // Zoradi články podľa dátumu od najmladšieho po najstarší
  const sorted = filtered.sort((a, b) => {
    if (!a.create || !b.create) return 0
    return new Date(b.create) - new Date(a.create)
  })



  return sorted
})

const articleColumns = computed(() => {
  const columns = [[], [], []]
  contentArticles.value.forEach((card, index) => {
    columns[index % 3].push(card)
  })
  return columns
})


const loadData = async (params = { take: 8, skip: 0 }) => {

  console.log(route)
  loadingContent.value = true
  try {
    const response = await axios.get('/read/list/', { params })
    loadingContent.value = false
    let url = ''
    if (route.name === 'Podcast') {
      url = '/read/podcasts/'
    }
    if (!params.skip) {
      content.value = response.data
    } else {
      content.value = content.value.concat(response.data)
    }

    if (content.value.length) {
      document.title = `${content.value[0].name} - ICJK`
    }

    dataCount.value = content.value.length

    if (response.data.length === 0) {
      allLoaded.value = true
    } else {
      allLoaded.value = false
    }
  } catch (error) {
    loadingContent.value = false
    console.error('Chyba pri načítaní dát:', error)
  }
}


const getURLText = (text) => {
  return unorm
    .nfd(text)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^\sA-Za-z0-1]/g, '')
    .replace(/\s+/g, '-')
}

const dateFilter = (value) => {
  if (!value) return ''
  const d = new Date(value.toString())
  const months = [
    'Január',
    'Február',
    'Marec',
    'Apríl',
    'Máj',
    'Jún',
    'Júl',
    'August',
    'September',
    'Október',
    'November',
    'December'
  ]
  return `${d.getDate()}. ${months[d.getMonth()].toLowerCase()} ${d.getFullYear()}`
}


onMounted(() => {

  loadData()
  scroll()
})
</script>

<style scoped>
.circlePop {
  width: min(90vw, 420px) !important;
  height: min(90vw, 420px);
  border-radius: 50% !important;
  overflow: hidden;
  background: rgba(var(--v-theme-primary), 0.70) !important;
  ;
  /* mierna priehľadnosť */
  backdrop-filter: blur(4px) !important;
  ;
  /* pekný moderný efekt */
}

.titleBg {
  background: rgba(var(--v-theme-primary), 0.70) !important;
  /* mierna priehľadnosť */
  backdrop-filter: blur(4px) !important;
  /* pekný moderný efekt */
}

.red-ring {
  position: absolute;

  width: 450px;
  height: 450px;

  border-radius: 50%;
  background: #ef7d7d;

  left: -160px;
  top: 90%;

  transform: translateY(-50%);
  z-index: 0;

}

.small-red-ring {
  position: absolute;
  background: rgba(239, 125, 125, 0.8);
  width: 200px;
  height: 200px;

  border-radius: 50%;

  left: -50px;
  top: 80%;

  transform: translateY(-50%);
  z-index: 0;
}



.podcast-date {
  margin: 25px 0 15px 15px;
}

.podcastLabel {
  position: absolute;

  top: 50%;
  left: 20px;

  transform: translateY(-50%);
  z-index: 2;
}

.podcastTitle,
.podcastSecondTitle {
  display: inline-block;

  color: white;
  background: black;

  padding: 0px 16px;
  text-align: left;
  font-size: 4rem;
  font-weight: 700;
  line-height: 1;
}

.podcastSecondTitle {
  margin-top: 8px;
  display: block;
  width: max-content;
}

.podcastSection {
  position: absolute;
  left: 32px;
  top: 190px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1px;
}

.podcastSection span {
  background: #ee3d4b;
  color: white;

  padding: 1px 4px;

  font-size: 1rem;
  font-weight: 700;
  line-height: 1;
}

.podcast-image {
  width: 100%;
  display: block;
  margin-top: 8px;
}



.square-img {
  width: 400px;
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.imgWrapper {
  width: 300px;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  box-shadow: none;
}

h2 {
  line-height: 1.2;
}
</style>